/* Southbay JDM – theme scripts (no dependencies) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var T = window.theme || { routes: {}, strings: {} };

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return value.split('.')[0];
      return value;
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = $('#MenuDrawer');
    if (!drawer) return;
    var open = function () { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; var f = $('a,button,input', $('.drawer__panel', drawer)); if (f) f.focus(); };
    var close = function () { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }
  function showToast(html) {
    var t = $('#CartToast');
    if (!t) return;
    t.innerHTML = html;
    t.hidden = false;
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function addToCart(id, qty) {
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function refreshCount() {
    return fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); return c; });
  }
  function initProductForms() {
    $$('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.name === 'checkout') return;
        e.preventDefault();
        var btn = $('[type=submit]', form);
        var id = form.querySelector('[name=id]').value;
        var qtyEl = form.querySelector('[name=quantity]');
        var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        btn.disabled = true;
        addToCart(id, qty).then(function () {
          return refreshCount();
        }).then(function () {
          showToast('<span>' + T.strings.added + '</span><a href="' + T.routes.cart + '">' + T.strings.viewCart + '</a>');
        }).catch(function (err) {
          showToast('<span>' + ((err && (err.description || err.message)) || T.strings.error) + '</span>');
        }).finally(function () { btn.disabled = false; });
      });
    });
  }

  /* ---------- Quantity buttons ---------- */
  function initQty() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      $$('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.hasAttribute('data-qty-plus') ? 1 : -1;
          var min = parseInt(input.min || '1', 10);
          var max = input.max ? parseInt(input.max, 10) : 9999;
          var v = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 1) + step));
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Gallery + lightbox ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      var slides = $$('.gallery__slide', g);
      var thumbs = $$('.gallery__thumb', g);
      var counter = $('[data-counter]', g);
      var i = 0;
      function go(n) {
        if (!slides.length) return;
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var prev = $('.gallery__nav--prev', g), next = $('.gallery__nav--next', g);
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      var more = $('.gallery__more', g);
      if (more) more.addEventListener('click', function () { more.parentElement.classList.remove('is-collapsed'); more.remove(); });
      // swipe
      var x0 = null;
      var main = $('.gallery__main', g);
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
      }
      // lightbox
      var lb = $('#Lightbox');
      if (lb) {
        var lbImg = $('img', lb);
        var show = function () { var img = $('img', slides[i]); lbImg.src = img.getAttribute('data-zoom') || img.currentSrc || img.src; lbImg.alt = img.alt; };
        slides.forEach(function (s) { var img = $('img', s); if (img) img.addEventListener('click', function () { show(); lb.hidden = false; $('.lightbox__close', lb).focus(); }); });
        $('.lightbox__close', lb).addEventListener('click', function () { lb.hidden = true; });
        $('.lightbox__prev', lb).addEventListener('click', function () { go(i - 1); show(); });
        $('.lightbox__next', lb).addEventListener('click', function () { go(i + 1); show(); });
        lb.addEventListener('click', function (e) { if (e.target === lb) lb.hidden = true; });
        document.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'Escape') lb.hidden = true;
          if (e.key === 'ArrowLeft') { go(i - 1); show(); }
          if (e.key === 'ArrowRight') { go(i + 1); show(); }
        });
      }
      go(0);
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (tabs) {
      var btns = $$('[role=tab]', tabs);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (o) {
            var on = o === b;
            o.setAttribute('aria-selected', on ? 'true' : 'false');
            o.tabIndex = on ? 0 : -1;
            var p = document.getElementById(o.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
        b.addEventListener('keydown', function (e) {
          var idx = btns.indexOf(b);
          if (e.key === 'ArrowRight') { btns[(idx + 1) % btns.length].focus(); btns[(idx + 1) % btns.length].click(); }
          if (e.key === 'ArrowLeft') { btns[(idx - 1 + btns.length) % btns.length].focus(); btns[(idx - 1 + btns.length) % btns.length].click(); }
        });
      });
    });
  }

  /* ---------- Modals ---------- */
  function initModals() {
    $$('[data-modal-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var m = document.getElementById(b.getAttribute('data-modal-open'));
        if (!m) return;
        m.hidden = false;
        var f = $('input,select,button', m); if (f) f.focus();
      });
    });
    $$('.modal').forEach(function (m) {
      m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-modal-close]')) m.hidden = true; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') m.hidden = true; });
    });
  }

  /* ---------- Shipping estimator (uses Shopify shipping rates) ---------- */
  function initShipping() {
    $$('[data-shipping-estimator]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var out = $('[data-result]', form);
        var btn = $('[type=submit]', form);
        var variantId = form.getAttribute('data-variant-id');
        var params = 'shipping_address[zip]=' + encodeURIComponent(form.zip.value) +
          '&shipping_address[country]=' + encodeURIComponent(form.country.value) +
          '&shipping_address[province]=' + encodeURIComponent(form.province.value);
        btn.disabled = true;
        out.innerHTML = '<p>' + T.strings.calculating + '</p>';
        var ready = Promise.resolve(null);
        if (variantId) {
          ready = fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            var inCart = cart.items.some(function (it) { return String(it.variant_id) === String(variantId); });
            if (inCart) return null;
            return addToCart(variantId, 1).then(function () { refreshCount(); return 'added'; });
          });
        }
        ready.then(function (added) {
          return fetch(T.routes.cart + '/prepare_shipping_rates.json?' + params, { method: 'POST' }).then(function () {
            var tries = 0;
            function poll() {
              return fetch(T.routes.cart + '/async_shipping_rates.json?' + params).then(function (r) { return r.json(); }).then(function (d) {
                if (d && d.shipping_rates) return { rates: d.shipping_rates, added: added };
                if (++tries > 10) throw new Error('timeout');
                return new Promise(function (res) { setTimeout(res, 600); }).then(poll);
              });
            }
            return poll();
          });
        }).then(function (res) {
          var html = '';
          if (res.added) html += '<p><small>' + T.strings.addedForEstimate + '</small></p>';
          if (!res.rates.length) {
            html += '<p class="is-error">' + T.strings.noRates + '</p>';
          } else {
            html += '<p><strong>' + T.strings.ratesFor.replace('{{ zip }}', form.zip.value) + '</strong></p><ul>';
            res.rates.forEach(function (rate) { html += '<li>' + rate.name + ': <strong>' + (rate.price === '0.00' ? 'Free' : formatMoney(Math.round(parseFloat(rate.price) * 100))) + '</strong></li>'; });
            html += '</ul>';
          }
          out.innerHTML = html;
        }).catch(function () {
          out.innerHTML = '<p class="is-error">' + T.strings.noRates + '</p>';
        }).finally(function () { btn.disabled = false; });
      });
    });
  }

  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readVehicles(el) { var v = { makes: [] }; if (el) { try { v = JSON.parse(el.textContent); } catch (e) {} } return v.makes ? v : { makes: [] }; }
  function makeOptions(makes) { return makes.map(function (m) { return '<option value="' + esc(m.v) + '">' + esc(m.l) + '</option>'; }).join(''); }
  function modelOptions(make, placeholder) {
    return '<option value="">' + esc(placeholder) + '</option>' + (make ? make.m.map(function (x) { return '<option value="' + esc(x[0]) + '">' + esc(x[1]) + '</option>'; }).join('') : '');
  }

  /* ---------- Vehicle finder (Year / Make / Model → collection page with the filter set) ---------- */
  function initFinder(scope) {
    $$('[data-finder]', scope).forEach(function (form) {
      if (form._finder) return;
      form._finder = true;
      var V = readVehicles($('script[type="application/json"]', form));
      var map = {};
      V.makes.forEach(function (m) { map[m.v] = m; });
      var make = form.querySelector('[name=make]');
      var model = form.querySelector('[name=model]');
      var year = form.querySelector('[name=year]');
      make.insertAdjacentHTML('beforeend', makeOptions(V.makes));
      function fillModels() {
        var m = map[make.value];
        model.innerHTML = modelOptions(m, model.getAttribute('data-placeholder'));
        model.disabled = !m || !m.m.length;
      }
      make.addEventListener('change', fillModels);
      fillModels();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qs = new URLSearchParams();
        if (year.value) qs.set('year', year.value);
        if (make.value) qs.set('make', make.value);
        if (model.value) qs.set('model', model.value);
        var q = qs.toString();
        window.location.href = form.getAttribute('action') + (q ? '?' + q : '');
      });
    });
  }

  /* Height of the header when it stays on screen while scrolling (0 when it scrolls away) */
  function stuckHeader() {
    var hdr = $('.header');
    if (!hdr) return 0;
    var wrap = hdr.parentElement;
    var pos = wrap ? window.getComputedStyle(wrap).position : '';
    return (pos === 'sticky' || pos === 'fixed') ? hdr.offsetHeight : 0;
  }

  /* ---------- Collection filter sidebar: Search · Year · Make · Model · Category · Price · Condition · In stock ----------
     Works in the browser over every product of the collection (rendered by sections/main-collection.liquid).
     URL parameters (old-site names): ?search=&year=&make=&model=&category=a,b&minPrice=&maxPrice=&condition=a,b&inStock=true&sort=&pg=  (old category[0]= links still work) */
  function initCollectionFilter(scope) {
    $$('[data-pf]', scope).forEach(function (root) {
      if (root._pf) return;
      root._pf = true;
      var grid = $('[data-pf-grid]', root);
      var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 12;
      var S = {};
      try { S = JSON.parse(($('script[data-pf-strings]', root.parentNode) || {}).textContent || '{}'); } catch (e) {}
      var el = {
        search: $('[data-pf-search]', root), year: $('[data-pf-year]', root), make: $('[data-pf-make]', root),
        model: $('[data-pf-model]', root), min: $('[data-pf-min]', root), max: $('[data-pf-max]', root),
        stock: $('[data-pf-stock]', root), sort: $('[data-pf-sort]', root), cats: $$('[data-pf-cat]', root),
        conds: $$('[data-pf-cond]', root), showing: $('[data-pf-showing]', root), chips: $('[data-pf-chips]', root),
        empty: $('[data-pf-empty]', root), pager: $('[data-pf-pager]', root), done: $('[data-pf-done]', root),
        panel: $('[data-pf-panel]', root), side: $('.coll-sidebar', root)
      };
      var data = (grid ? $$('[data-pf-item]', grid) : []).map(function (n, i) {
        var d = n.dataset;
        return {
          n: n, i: i, sku: parseInt(d.sku, 10) || 0, price: parseInt(d.price, 10) || 0, title: d.title || '',
          make: d.make || '', model: d.model || '', years: (d.years || '').split(/\s+/), cond: d.cond || '',
          avail: d.avail === 'true', cols: (d.cols || '').split(/\s+/), q: (d.q || '').toLowerCase()
        };
      });

      /* Year / Make / Model lists */
      var V = readVehicles($('script[data-pf-vehicles]', root));
      var makeMap = {};
      V.makes.forEach(function (m) { makeMap[m.v] = m; });
      if (el.make) el.make.insertAdjacentHTML('beforeend', makeOptions(V.makes));
      function fillModels() {
        if (!el.model) return;
        el.model.innerHTML = modelOptions(makeMap[el.make ? el.make.value : ''], S.allModels || 'All Models');
      }

      /* Category counts (products of this collection in each category) */
      el.cats.forEach(function (cb) {
        var c = data.filter(function (d) { return d.cols.indexOf(cb.value) !== -1; }).length;
        var out = $('[data-pf-count-for="' + cb.value + '"]', root);
        if (out) out.textContent = '(' + c + ')';
      });

      /* State <-> URL <-> controls */
      var state;
      function readUrl() {
        var qs = new URLSearchParams(window.location.search);
        function list(name) {
          var out = [];
          qs.forEach(function (v, k) {
            if (k !== name && k.indexOf(name + '[') !== 0) return;
            var vals = /=>/.test(v) ? (v.match(/=>\s*"([^"]*)"/g) || []).map(function (x) { return x.replace(/^=>\s*"|"$/g, ''); }) : v.split(',');
            vals.forEach(function (x) { x = x.trim().toLowerCase(); if (x && out.indexOf(x) === -1) out.push(x); });
          });
          return out;
        }
        return {
          q: qs.get('search') || '', year: qs.get('year') || '', make: (qs.get('make') || '').toLowerCase(),
          model: (qs.get('model') || '').toLowerCase(), cats: list('category'), conds: list('condition'),
          min: qs.get('minPrice') || '', max: qs.get('maxPrice') || '', stock: qs.get('inStock') === 'true',
          sort: qs.get('sort') || 'newest', page: parseInt(qs.get('pg'), 10) || 1
        };
      }
      function toUi() {
        if (el.search) el.search.value = state.q;
        if (el.year) el.year.value = state.year;
        if (el.make) { el.make.value = state.make; if (el.make.value !== state.make) { state.make = ''; el.make.value = ''; } }
        fillModels();
        if (el.model) { el.model.value = state.model; if (el.model.value !== state.model) { el.model.value = ''; if (el.make) state.model = ''; } }
        el.cats.forEach(function (cb) { cb.checked = state.cats.indexOf(cb.value) !== -1; });
        el.conds.forEach(function (cb) { cb.checked = state.conds.indexOf(cb.value) !== -1; });
        if (el.min) el.min.value = state.min;
        if (el.max) el.max.value = state.max;
        if (el.stock) el.stock.checked = state.stock;
        if (el.sort) { el.sort.value = state.sort; if (el.sort.value !== state.sort) { state.sort = 'newest'; el.sort.value = 'newest'; } }
      }
      function fromUi() {
        if (el.search) state.q = el.search.value.trim();
        if (el.year) state.year = el.year.value;
        if (el.make) state.make = el.make.value;
        if (el.model) state.model = el.model.value;
        if (el.cats.length) state.cats = el.cats.filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; });
        if (el.conds.length) state.conds = el.conds.filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; });
        if (el.min) state.min = el.min.value;
        if (el.max) state.max = el.max.value;
        if (el.stock) state.stock = el.stock.checked;
        if (el.sort) state.sort = el.sort.value;
      }
      function writeUrl() {
        var qs = new URLSearchParams(window.location.search);
        var drop = [];
        qs.forEach(function (v, k) { if (/^(search|year|make|model|minPrice|maxPrice|inStock|sort|pg)$/.test(k) || /^(category|condition)(\[\d*\])?$/.test(k)) drop.push(k); });
        drop.forEach(function (k) { qs.delete(k); });
        if (state.q) qs.set('search', state.q);
        if (state.year) qs.set('year', state.year);
        if (state.make) qs.set('make', state.make);
        if (state.model) qs.set('model', state.model);
        if (state.cats.length) qs.set('category', state.cats.join(','));
        if (state.min !== '') qs.set('minPrice', state.min);
        if (state.max !== '') qs.set('maxPrice', state.max);
        if (state.conds.length) qs.set('condition', state.conds.join(','));
        if (state.stock) qs.set('inStock', 'true');
        if (state.sort && state.sort !== 'newest') qs.set('sort', state.sort);
        if (state.page > 1) qs.set('pg', state.page);
        var q = qs.toString().replace(/%2C/gi, ',');
        try { history.replaceState(history.state, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash); } catch (e) {}
      }

      /* Matching + sorting */
      function match(d) {
        if (state.q) {
          var words = state.q.toLowerCase().split(/\s+/);
          for (var w = 0; w < words.length; w++) { if (words[w] && d.q.indexOf(words[w]) === -1) return false; }
        }
        if (state.year && d.years.indexOf(String(state.year)) === -1) return false;
        if (state.make && d.make !== state.make) return false;
        if (state.model && d.model !== state.model) return false;
        if (state.cats.length && !state.cats.some(function (c) { return d.cols.indexOf(c) !== -1; })) return false;
        if (state.conds.length && state.conds.indexOf(d.cond) === -1) return false;
        var price = d.price / 100;
        if (state.min !== '' && !isNaN(parseFloat(state.min)) && price < parseFloat(state.min)) return false;
        if (state.max !== '' && !isNaN(parseFloat(state.max)) && price > parseFloat(state.max)) return false;
        if (state.stock && !d.avail) return false;
        return true;
      }
      var sorters = {
        newest: function (a, b) { return (b.sku - a.sku) || (a.i - b.i); },
        price_asc: function (a, b) { return (a.price - b.price) || (b.sku - a.sku); },
        price_desc: function (a, b) { return (b.price - a.price) || (b.sku - a.sku); },
        name_asc: function (a, b) { return a.title.localeCompare(b.title, undefined, { sensitivity: 'base', numeric: true }) || (b.sku - a.sku); }
      };

      /* Chips */
      var chipFns = [];
      function money(v) { return formatMoney(Math.round(parseFloat(v) * 100)).replace(/[.,]00(?=\D*$)/, ''); }
      function labelOf(list, v) { for (var i = 0; i < list.length; i++) { if (list[i].value === v) return list[i].getAttribute('data-label') || v; } return v; }
      function optLabel(sel, v) { if (!sel) return v; for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].value === v) return sel.options[i].textContent; } return v; }
      function chips() {
        var c = [];
        if (state.q) c.push([(S.search || 'Search') + ': ' + state.q, function () { state.q = ''; }]);
        if (state.year) c.push([(S.year || 'Year') + ': ' + state.year, function () { state.year = ''; }]);
        if (state.make) c.push([(S.make || 'Make') + ': ' + optLabel(el.make, state.make), function () { state.make = ''; state.model = ''; }]);
        if (state.model) c.push([(S.model || 'Model') + ': ' + optLabel(el.model, state.model), function () { state.model = ''; }]);
        state.cats.forEach(function (v) { c.push([labelOf(el.cats, v), function () { state.cats = state.cats.filter(function (x) { return x !== v; }); }]); });
        if (state.min !== '' || state.max !== '') {
          var txt = state.min !== '' && state.max !== '' ? money(state.min) + ' - ' + money(state.max) : (state.min !== '' ? money(state.min) + '+' : money(0) + ' - ' + money(state.max));
          c.push([(S.price || 'Price') + ': ' + txt, function () { state.min = ''; state.max = ''; }]);
        }
        state.conds.forEach(function (v) { c.push([labelOf(el.conds, v), function () { state.conds = state.conds.filter(function (x) { return x !== v; }); }]); });
        if (state.stock) c.push([S.stock || 'In Stock', function () { state.stock = false; }]);
        chipFns = c.map(function (x) { return x[1]; });
        if (!el.chips) return;
        el.chips.innerHTML = c.map(function (x, i) {
          return '<button type="button" class="pf-chip" data-chip="' + i + '" aria-label="' + esc((S.remove || 'Remove') + ': ' + x[0]) + '">' + esc(x[0]) +
            ' <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>';
        }).join('');
        el.chips.hidden = !c.length;
      }

      /* Pager */
      var chevL = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
      var chevR = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
      function pager(total, pages, start, end) {
        if (!el.pager) return;
        if (!total) { el.pager.innerHTML = ''; return; }
        var html = '<p class="pf-pager__text">' + esc((S.range || 'Showing __F__ to __T__ of __N__ results').replace('__F__', start + 1).replace('__T__', end).replace('__N__', total)) + '</p>';
        if (pages > 1) {
          var p = state.page, nums = [];
          if (pages <= 10) { for (var i = 1; i <= pages; i++) nums.push(i); }
          else {
            nums.push(1);
            if (p > 3) nums.push('…');
            for (var j = Math.max(2, p - 1); j <= Math.min(pages - 1, p + 1); j++) nums.push(j);
            if (p < pages - 2) nums.push('…');
            nums.push(pages);
          }
          html += '<nav class="pf-pages" aria-label="' + esc(S.pagination || 'Pagination') + '">' +
            '<button type="button" class="pf-pages__btn" data-pg="' + (p - 1) + '" aria-label="' + esc(S.prev || 'Previous') + '"' + (p === 1 ? ' disabled' : '') + '>' + chevL + '</button>' +
            nums.map(function (n) {
              if (n === '…') return '<span class="pf-pages__btn pf-pages__gap">…</span>';
              return '<button type="button" class="pf-pages__btn' + (n === p ? ' is-current" aria-current="page' : '') + '" data-pg="' + n + '" aria-label="' + esc((S.page || 'Page __P__').replace('__P__', n)) + '">' + n + '</button>';
            }).join('') +
            '<button type="button" class="pf-pages__btn" data-pg="' + (p + 1) + '" aria-label="' + esc(S.next || 'Next') + '"' + (p === pages ? ' disabled' : '') + '>' + chevR + '</button></nav>';
        }
        el.pager.innerHTML = html;
      }

      function render(scroll) {
        var res = data.filter(match).sort(sorters[state.sort] || sorters.newest);
        var pages = Math.max(1, Math.ceil(res.length / perPage));
        if (state.page > pages) state.page = pages;
        if (state.page < 1) state.page = 1;
        var start = (state.page - 1) * perPage;
        var end = Math.min(start + perPage, res.length);
        data.forEach(function (d) { d.n.hidden = true; });
        res.forEach(function (d, i) { if (grid) grid.appendChild(d.n); d.n.hidden = i < start || i >= end; });
        if (grid) grid.hidden = !res.length;
        if (el.empty) el.empty.hidden = !!res.length;
        if (el.showing && S.showing) el.showing.innerHTML = S.showing.replace('__N__', res.length);
        if (el.done && S.results) el.done.textContent = S.results.replace('__N__', res.length);
        chips();
        pager(res.length, pages, start, end);
        writeUrl();
        if (scroll) {
          var top = root.getBoundingClientRect().top + window.pageYOffset - stuckHeader() - 16;
          if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
      function update() { fromUi(); state.page = 1; render(false); }
      var timer;
      function later(ms) { clearTimeout(timer); timer = setTimeout(update, ms); }

      if (el.search) el.search.addEventListener('input', function () { later(250); });
      if (el.min) el.min.addEventListener('input', function () { later(450); });
      if (el.max) el.max.addEventListener('input', function () { later(450); });
      if (el.make) el.make.addEventListener('change', function () { fillModels(); update(); });
      [el.year, el.model, el.sort, el.stock].forEach(function (x) { if (x) x.addEventListener('change', update); });
      el.cats.concat(el.conds).forEach(function (x) { x.addEventListener('change', update); });
      $$('[data-pf-clear]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          var sort = state.sort;
          state = { q: '', year: '', make: '', model: '', cats: [], conds: [], min: '', max: '', stock: false, sort: sort, page: 1 };
          toUi();
          render(false);
        });
      });
      if (el.chips) el.chips.addEventListener('click', function (e) {
        var b = e.target.closest('[data-chip]');
        if (!b) return;
        var fn = chipFns[parseInt(b.getAttribute('data-chip'), 10)];
        if (fn) { fn(); state.page = 1; toUi(); render(false); }
      });
      if (el.pager) el.pager.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-pg]');
        if (!b || b.disabled) return;
        state.page = parseInt(b.getAttribute('data-pg'), 10) || 1;
        render(true);
      });
      $$('.js-open-filters', root).forEach(function (b) { b.addEventListener('click', function () { if (el.side) el.side.classList.add('is-open'); }); });
      $$('.js-close-filters', root).forEach(function (b) { b.addEventListener('click', function () { if (el.side) el.side.classList.remove('is-open'); }); });
      if (el.panel) el.panel.style.setProperty('--pf-top', (stuckHeader() + 16) + 'px');

      state = readUrl();
      toUi();
      render(false);
      root.classList.add('is-ready');
    });
  }

  /* ---------- Collection filters + sort ---------- */
  function initFacets() {
    var form = $('[data-facets-form]');
    var sort = $('[data-sort]');
    function go(f) {
      var data = new FormData(f || form);
      var qs = new URLSearchParams();
      data.forEach(function (v, k) { if (v !== '') qs.append(k, v); });
      if (sort && sort.value) qs.set('sort_by', sort.value);
      window.location.search = qs.toString();
    }
    if (form) {
      $$('[data-facet-input]', form).forEach(function (i) { i.addEventListener('change', function () { go(form); }); });
      form.addEventListener('submit', function (e) { e.preventDefault(); go(form); });
    }
    if (sort) sort.addEventListener('change', function () {
      if (form) return go(form);
      var qs = new URLSearchParams(window.location.search);
      qs.set('sort_by', sort.value);
      window.location.search = qs.toString();
    });
    var side = $('.coll-sidebar');
    if (!side || side.closest('[data-pf]')) return;
    $$('.js-open-filters').forEach(function (b) { b.addEventListener('click', function () { side.classList.add('is-open'); }); });
    $$('.js-close-filters').forEach(function (b) { b.addEventListener('click', function () { side.classList.remove('is-open'); }); });
  }

  /* ---------- Cart page quantity auto-update ---------- */
  function initCartPage() {
    var form = $('#CartForm');
    if (!form) return;
    $$('input[name="updates[]"]', form).forEach(function (i) {
      i.addEventListener('change', function () { form.submit(); });
    });
  }

  document.addEventListener('shopify:section:load', function (e) { initFinder(e.target); initCollectionFilter(e.target); });

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer(); initProductForms(); initQty(); initGallery(); initTabs(); initModals(); initShipping(); initFinder(); initCollectionFilter(); initFacets(); initCartPage();
  });
})();

/* Old-site /shop links (also /shop?make=x) open the matching collection */
if (location.pathname === '/shop') { var sbMake = new URLSearchParams(location.search).get('make'); location.replace(sbMake ? '/collections/' + encodeURIComponent(sbMake.toLowerCase()) : '/collections/all'); }
